import { getFormattedValidationErrorFromAction } from 'Utils/getFormattedValidationErrorFromAction';

export const FETCH_PACKAGES_BY_SUPPLIERID = `FETCH_PACKAGES_BY_SUPPLIERID`;
export const FETCH_PACKAGES_BY_SUPPLIERID_FAIL = `${FETCH_PACKAGES_BY_SUPPLIERID}_FAIL`;
export const FETCH_PACKAGES_BY_SUPPLIERID_SUCCESS = `${FETCH_PACKAGES_BY_SUPPLIERID}_SUCCESS`;
export const REDEMPTION_FUEL_CREDIT = `REDEMPTION_FUEL_CREDIT`;
export const REDEMPTION_FUEL_CREDIT_FAIL = `${REDEMPTION_FUEL_CREDIT}_FAIL`;
export const REDEMPTION_FUEL_CREDIT_SUCCESS = `${REDEMPTION_FUEL_CREDIT}_SUCCESS`;
export const REDEMPTION_FUEL_CREDIT_RESET = `${REDEMPTION_FUEL_CREDIT}_RESET`;

const initialStateDefault = {
  packages: [],
  isLoading: false,
  filled: false,
  finishRequests: false,
  isLoadingFuelCredit: false,
  isError: false,
  error: null,
  sendRedemption: false,
  sendRedemptionError: false,
};

const FuelCreditReducer = (state = initialStateDefault, action) => {
  switch (action.type) {
    case FETCH_PACKAGES_BY_SUPPLIERID:
      return {
        ...state,
        isLoading: true,
        packages: [],
        filled: false,
        finishRequest: false,
        isError: false,
      };
    case FETCH_PACKAGES_BY_SUPPLIERID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        package: [...action.payload.data],
        filled: true,
        finishRequests: true,
        isError: false,
        statusCode: action?.payload?.statusCode,
      };
    case FETCH_PACKAGES_BY_SUPPLIERID_FAIL:
      const errorData = getFormattedValidationErrorFromAction(action);
      return {
        ...state,
        isLoading: false,
        package: [],
        error: errorData,
        filled: false,
        finishRequests: true,
        isError: true,
        statusCode: action?.error?.response?.status,
      };
    case REDEMPTION_FUEL_CREDIT:
      return {
        ...state,
        sendRedemption: true,
        sendSuccess: false,
        isLoadingFuelCredit: true,
      };
    case REDEMPTION_FUEL_CREDIT_SUCCESS:
      return {
        ...state,
        sendRedemption: false,
        sendSuccess: true,
        isError: false,
        isLoadingFuelCredit: false,
        status: action.payload?.status,
        statusCode: action.payload?.status,
        order: { ...action.payload?.order },
      };
    case REDEMPTION_FUEL_CREDIT_FAIL:
      return {
        ...state,
        sendRedemption: false,
        sendRedemptionError: true,
        sendSuccess: false,
        isLoadingFuelCredit: false,
        isError: true,
        status: action.payload?.data?.status,
        statusCode: action.payload?.statusCode,
        error: action.error,
      };
    case REDEMPTION_FUEL_CREDIT_RESET:
      return {
        ...state,
        ...initialStateDefault,
      };
    default:
      return state || initialStateDefault;
  }
};
export default FuelCreditReducer;
